import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { setDashboardStatus } from "../../store/reducers/dashboardSlice";
import { setUser as setUserAction, useSetUserLoggedIn } from "./LoginComp";
import useAuth from "../../auth/hooks/useAuth";
import {
  deploymentTypes,
  selected_authentication_server,
  servers,
  serverType,
} from "../../deployment-config";
import { setMasquerade } from "../../store/reducers/reducer-auth";
import useLogout from "../../hooks/useLogout";
import {
  setIsSavedReport,
  setReportDocumentStatus,
} from "../../store/reducers/reportDocumentSlice";
import { Spinner } from "react-bootstrap";
let server_address =
  serverType === deploymentTypes.development
    ? servers.development
    : deploymentTypes.localDevelopment
    ? servers.localDevelopment
    : servers.production;
const environment_hostname = "https://" + server_address + "/api/v1";

const MasqueradeComponent = () => {
  const logout = useLogout();
  const [searchParams] = useSearchParams();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setAuth } = useAuth();
  const cookies = new Cookies();
  const setUserLoggedIn = useSetUserLoggedIn();
  useEffect(() => {
    const p_logged_in_email = searchParams.get("p_logged_in_email");
    const p_session = searchParams.get("p_session");
    const p_ticket_id = searchParams.get("p_ticket_id");
    const p_customer_contact_id = searchParams.get("p_customer_contact_id");
    if (p_logged_in_email) {
      masqueradeLogin(
        p_logged_in_email,
        p_session,
        p_ticket_id,
        p_customer_contact_id
      );
    } else {
      navigate("/unauthorized");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, navigate, dispatch, setAuth, cookies]);

  const masqueradeLogin = async (
    p_logged_in_email,
    p_session,
    p_ticket_id,
    p_customer_contact_id
  ) => {
    try {
      // Mimic the login flow
      dispatch(setDashboardStatus("idle"));
      dispatch(setReportDocumentStatus("idle"));
      dispatch(setIsSavedReport(false));
      localStorage.clear();

      const response = await axios.post(
        `${environment_hostname}/auth/masquerade`, // Replace with your actual server URL
        {
          p_logged_in_email: p_logged_in_email,
          p_session: p_session,
          p_ticket_id: p_ticket_id,
          p_customer_contact_id: p_customer_contact_id,
        }
      );
      const res = response;
      if (res.data.userid) {
        await setUserAction({ res, setIsLoggedIn, cookies, dispatch });

        // Fetch user data like accounts and roles
        const res2 = await axios.post(
          selected_authentication_server.access_account.endpoint,
          { userid: res.data.userid },
          // { headers: selected_authentication_server.access_account.headers }
          {
            headers: {
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          }
        );
        // Now that we have all necessary data, set the user as logged in
        dispatch(
          setMasquerade({
            isIt: true,
            p_logged_in_email,
            p_session,
            p_ticket_id,
            p_customer_contact_id,
          })
        );
        setUserLoggedIn({ res: res2 });
      } else {
        logout();
      }
      // Set the user as logged in
    } catch (error) {
      console.error("Masquerade failed", error);
      navigate("/unauthorized");
    }
  };

  return (
    <section
      className="h-100 gradient-form d-sm-flex align-items-sm-center"
      style={{
        minHeight: "100vh",

        backgroundBlendMode: "multiply",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="d-flex justify-content-center align-items-center w-100">
        <div className="d-flex align-items-center justify-content-center gap-2">
          <h2 className="text-primary">Masquerading </h2>
          <div className="d-flex gap-3">
            <div>
              <Spinner animation="grow" size="sm" variant="primary" />
            </div>
            <div>
              <Spinner animation="grow" size="sm" variant="primary" />
            </div>
            <div>
              <Spinner animation="grow" size="sm" variant="primary" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MasqueradeComponent;

// The setUser function is assumed to be similar to the one provided in LoginComponent
// but it should also handle the functionality of setting the user state for masquerade.
// const setUser = async ({ res, dispatch, cookies }) => {
//   // ... Your existing setUser implementation
//   // You would set the AUTH-TOKEN and user-related state here
// };

// The setUserLoggedIn function is assumed to be similar to the one provided in LoginComponent
// with adjustments for setting the user state after masquerading.
// const setUserLoggedIn = ({ res, setAuth, dispatch, navigate }) => {
//   // ... Your existing setUserLoggedIn implementation
//   // You would set the user's authentication state and navigate to dashboard here
// };
